export interface MenuState {
  openMenu: boolean;
}

const MenuStore = {
  namespaced: true,
  state: {
    openMenu: false,
  } as MenuState,
  mutations: {
    saveMenu(state: MenuState, openMenu: boolean) {
      state.openMenu = openMenu;
    },
  },
  actions: {
    toggleMenu({
      commit,
      state,
    }: {
      commit: (mutation: string, payload: any) => void;
      state: MenuState;
    }) {
      commit("saveMenu", !state.openMenu);
    },
  },
};

export default MenuStore;
